// extracted by mini-css-extract-plugin
export default {"row":"PlaceOrder_row__9Vrh+","cart":"PlaceOrder_cart__ZryYw"};